import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { saveImportedData } from 'redux-core/import-cuesheet/actions';

const mapDispatchToProps = { saveImportedData };

export default compose(connect(undefined, mapDispatchToProps), withBaseDrawer);
